import React from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getRawText } from "../../util";
import "./styles.css";
const findCorrectAnswers = panel => {
  let correctAnswers = [];
  for (let i = 0; i < panel.children.length; ++i) {
    let props = panel.children[i].props;
    switch (panel.children[i].tagName) {
      case "TaskMultiChoice":
        correctAnswers.push(`Correct Answer is ${props.choices[props.correct[0]]}`);
        break;
      case "TaskMultiSelect":
        {
          let response = "Correct Answers are";
          for (let j = 0; j < props.data.length; ++j) {
            if (props.data[j].correct) {
              if (j === 0) {
                response = response.concat(",");
              }
              response = response.concat(` ${props.data[j].label}`);
            }
          }
          correctAnswers.push(response);
        }
        break;
      case "TaskPassageClick":
        {
          let response = "Correct Answers are";
          let phraseCount = panel.children[i].children[0].children.length;
          let phrases = 0;
          for (let j = 0; j < phraseCount; ++j) {
            let phrase = panel.children[i].children[0].children[j];
            if (phrase.tagName === "TaskPassageClick.Click" && phrase.props.correct === true) {
              if (phrases !== 0) {
                response = response.concat(",");
              }
              response = response.concat(` ${getRawText(phrase)}`);
              phrases = phrases + 1;
            }
          }
          correctAnswers.push(response);
        }
        break;
      case "TaskMultiSelectSubmit":
        {
          let response = "Correct Answers are";
          for (let j = 0; j < props.data.length; ++j) {
            if (props.data[j].correct) {
              if (j !== 0) {
                response = response.concat(",");
              }
              response = response.concat(` ${getRawText(props.data[j].value)}`);
            }
          }
          correctAnswers.push(response);
        }
        break;
      case "TaskScaleBuilder":
        console.log("TaskScaleBuilder", props);
        {
          let response = "Correct Answers are";
          for (let j = 0; j < props.answers.length; ++j) {
            if (props.answers[j].correct) {
              if (j !== 0) {
                response = response.concat(",");
              }
              response = response.concat(` ${props.answers[j].answer}`);
            }
          }
          correctAnswers.push(response);
        }
      default:
        break;
    }
  }
  return correctAnswers;
};
const QAReport = ({
  panel,
  report,
  showReport,
  closeReport
}) => {
  return showReport && /*#__PURE__*/React.createElement("div", {
    className: "inspector-col QA-report"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "close-report-button",
    size: "sm",
    variant: "danger",
    onClick: closeReport
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-x",
    style: {
      margin: "auto 0px"
    }
  })), /*#__PURE__*/React.createElement("h4", null, "QA Report"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, report.length !== 0 ? /*#__PURE__*/React.createElement("div", null, report.map((v, k) => {
    return /*#__PURE__*/React.createElement("div", {
      key: k
    }, v);
  })) : /*#__PURE__*/React.createElement("div", null, "No Problems Found")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", null, panel && findCorrectAnswers(panel).map((v, k) => {
    return /*#__PURE__*/React.createElement("div", {
      key: k
    }, /*#__PURE__*/React.createElement("b", null, `Question ${k + 1}: `), v);
  })))));
};
export default QAReport;